function prvFloatingBar(){
    let myFloatingBar = document.getElementById('prv-floating-bar'); 
    if(window.innerWidth < 992){
        window.onscroll = function() {
            if(document.getElementById('form-lead-interesse').getBoundingClientRect().bottom < 0) {
                myFloatingBar.style.display = 'block';
            } else {
                myFloatingBar.style.display = 'none';
            }
        }
        if(document.getElementById('form-lead-interesse').getBoundingClientRect().bottom < 0) {
            myFloatingBar.style.display = 'block';
        }
    }
}

jQuery(function(){
	prvFloatingBar()
});